/**
 * @method getPercentageScrolled
 * @param {Element} frame - the iframe element
 * @returns {Number} a float representing a percentage, from 0 to 1
 */
const getPercentageScrolled = (frame) => {
  const activeContainer = frame.parentElement; // activeContainer
  const frameParent = activeContainer.parentElement;
  const maxScrollTop = frameParent.scrollHeight - frameParent.offsetHeight;

  if (maxScrollTop === 0) {
    return 0; // avoid divide by 0 error
  }

  // due to scaling used to zoom in/out, sometimes scrollTop is in decimal at the bottom of element,
  // this means percentageScrolled is sometimes not 1 even if bottom of page is reached, so round off scrollTop
  return Math.round(activeContainer.parentElement.scrollTop) / maxScrollTop;
};

export default getPercentageScrolled;
